import React, { useEffect, useRef, useState } from 'react';

export const ErrorBanner = ({ deviceTypeError, hardwareDeviceKeyError, onClose }) => {
    const hasError = deviceTypeError || hardwareDeviceKeyError;
    const [visible, setVisible] = useState(hasError);
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (hasError) {
            setVisible(true);
            // Clear any previous timeout
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            // Set timeout to auto-close after 10 seconds
            timeoutRef.current = setTimeout(() => {
                setVisible(false);
                if (onClose) onClose();
            }, 10000);
        } else {
            setVisible(false);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
        // Cleanup on unmount
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [hasError, onClose]);

    if (!hasError || !visible) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            fontWeight: 'bold',
            fontSize: '18px',
            backgroundColor: 'white',
            color: 'black',
            padding: '12px 16px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
            zIndex: 9999,
            maxWidth: '400px',
            minWidth: '300px',
            border: '1px solid #cc0000',
            animation: 'slideInFromLeft 0.3s ease-out'
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: '8px'
            }}>
                <div style={{ flex: 1 }}>
                    <div style={{
                        fontWeight: 'bold',
                        marginBottom: '4px',
                        fontSize: '18px',
                    }}>
                        <span role="img" aria-label="info">ℹ️</span> Device & Camera Configuration Info
                    </div>
                    {deviceTypeError || hardwareDeviceKeyError && (
                        <div style={{
                            fontSize: '16px',
                            marginBottom: deviceTypeError && hardwareDeviceKeyError ? '4px' : '0',
                            lineHeight: '1.4'
                        }}>
                        {deviceTypeError || hardwareDeviceKeyError}
                        </div>
                    )}
                </div>
                <button
                    onClick={onClose}
                    style={{
                        background: 'none',
                        border: 'none',
                        color: 'black',
                        cursor: 'pointer',
                        fontSize: '16px',
                        padding: '0',
                        marginLeft: '8px',
                        opacity: '0.8',
                        transition: 'opacity 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.opacity = '1'}
                    onMouseOut={(e) => e.target.style.opacity = '0.8'}
                >
                    ×
                </button>
            </div>
            <style jsx>{`
        @keyframes slideInFromLeft {
          from {
            transform: translateX(-100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes fadeOut {
          from {
            opacity: 1;
            transform: translateX(0);
          }
          to {
            opacity: 0;
            transform: translateX(-100%);
          }
        }
      `}</style>
        </div>
    );
};